module.exports = __webpack_public_path__ + "db43e7c80ee7417c105bddf796281368.svg";